import { render } from "./ReservaPublica.vue?vue&type=template&id=32fd3462&ts=true"
import script from "./ReservaPublica.vue?vue&type=script&lang=ts"
export * from "./ReservaPublica.vue?vue&type=script&lang=ts"

import "./ReservaPublica.vue?vue&type=style&index=0&id=32fd3462&lang=css"

import exportComponent from "D:\\UniParking\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__